import axios from "axios";
import {
  FreeTime,
} from "./dto/FreeTime";

// 初回無料日付取得
export const getFreeTime = async (date: string): Promise<FreeTime> => {
  const res = await axios.get<FreeTime>(`/api/freetime?date=${date}`, {
  });
  return res.data;
};

